/**
 * Ambient audio track definitions per club vibe.
 *
 * Vibes map to portal routes:
 *   lounge  → /portal/sponsor/, /sponsor/  (Focus / Jazz)
 *   commons → /portal/teacher/             (Lo-Fi / Acoustic)
 *   arena   → /portal/prospect/, /portal/locker/ (High Energy / Hype)
 *
 * Audio files are royalty-free. Replace URLs with Supabase Storage
 * or CDN-hosted files as they become available.
 */

export type Vibe = 'lounge' | 'commons' | 'arena';

export interface AmbientTrack {
  title: string;
  url: string;
  artist?: string;
  durationSeconds?: number;
}

export const AMBIENT_TRACKS: Record<Vibe, AmbientTrack[]> = {
  lounge: [
    { title: 'Evening Focus', url: 'https://cdn.pixabay.com/audio/2024/11/01/audio_a72597dba9.mp3', artist: 'Ambient' },
    { title: 'Quiet Momentum', url: 'https://cdn.pixabay.com/audio/2024/09/10/audio_6e5812e8ab.mp3', artist: 'Ambient' },
  ],
  commons: [
    { title: 'Morning Pages', url: 'https://cdn.pixabay.com/audio/2024/10/15/audio_89e8f1bd35.mp3', artist: 'Lo-Fi' },
    { title: 'Gentle Flow', url: 'https://cdn.pixabay.com/audio/2024/08/27/audio_dc39bbc0e8.mp3', artist: 'Acoustic' },
  ],
  arena: [
    { title: 'Game Day', url: 'https://cdn.pixabay.com/audio/2024/09/18/audio_26e5a44320.mp3', artist: 'Hype' },
    { title: 'Push Through', url: 'https://cdn.pixabay.com/audio/2024/11/14/audio_9a65deef44.mp3', artist: 'Energy' },
  ],
};

export const VIBE_LABELS: Record<Vibe, string> = {
  lounge: 'The Lounge',
  commons: 'The Commons',
  arena: 'The Arena',
};

export const VIBE_COLORS: Record<Vibe, string> = {
  lounge: '#C4A052',
  commons: '#B85C38',
  arena: '#0EA5E9',
};

/** Detect vibe from current pathname */
export function vibeFromPath(pathname: string): Vibe | null {
  if (pathname.startsWith('/portal/sponsor') || pathname.startsWith('/sponsor/')) return 'lounge';
  if (pathname.startsWith('/portal/teacher')) return 'commons';
  if (pathname.startsWith('/portal/prospect') || pathname.startsWith('/portal/locker')) return 'arena';
  return null;
}
